import './App.scss';
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react'
import AppContent from './components/AppContent/AppContent'
import Login from './components/Login/Login'
import { logOut } from './actions/userActions'
import { AlertTwoTone, WarningTwoTone } from '@ant-design/icons'
import { notification, ConfigProvider, theme } from 'antd'
import { isMobile } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import { formatText } from './helpers'
import { VAR_LOCALSTORAGE_DARKMODE } from './variables/localStorage'

let instanceMatomo = null;
if (process.env.REACT_APP_MATOMO_BASEURL && process.env.REACT_APP_MATOMO_SITEID) {
  instanceMatomo = createInstance({
    urlBase: process.env.REACT_APP_MATOMO_BASEURL,
    siteId: process.env.REACT_APP_MATOMO_SITEID,
    disabled: false,
    heartBeat: { active: true, seconds: 10 },
    linkTracking: false,
    configurations: {
      disableCookies: true,
      setSecureCookie: true,
      setRequestMethod: 'POST',
      setExcludedQueryParams: ['t']
    }
  });
}

const App = (props) => {
  const { user, logOut } = props
  const isConnected = user.infos !== undefined
  const loadingInfos = user.appload || null
  const { t } = useTranslation()

  const [darkMode, setDarkMode] = useState(() => localStorage.getItem(VAR_LOCALSTORAGE_DARKMODE) === 'true')

  useEffect(() => {
    document.documentElement.classList.toggle('dark-mode', darkMode)
    localStorage.setItem(VAR_LOCALSTORAGE_DARKMODE, darkMode)
  }, [darkMode])

  const handleClose = () => {
    //console.log('CLOSE Notif.')
  }
  const handleClick = () => {
    //console.log('CLICK Notif.')
  }

  const getInfos = (loadingInfos) => {
    const { action = null, code = null, origin } = loadingInfos
    const { id = null, mail = null } = origin
    var message = "", description = "", icon = null
    message = t('action_prise_en_compte')
    var text = t(action + '_' + code, { mail });
    description = text == (action + '_' + code) ? t('reconnectez_vous') : formatText(text)
    if (action == 'confirm_mail') {
      description = <span>
        {description}.<br />{formatText(t('email'))} : <em>{mail}</em>
      </span>
    }
    return { message, description, icon }
  }

  useEffect(() => {
    console.log('loadingInfos', loadingInfos)
    if (!isMobile && loadingInfos) {
      const infos = getInfos(loadingInfos)
      notification.open({
        message: infos && infos.message ? infos.message : "",
        description: <span>
          {
            infos && infos.description
              ? infos.description
              :
              <span>Références :
                <b>{loadingInfos.action}</b> #{loadingInfos.code}<br />
                Plus d'informations : <em>A venir</em>
              </span>
          }
        </span>,
        placement: isMobile ? 'topLeft' : 'bottomRight',
        icon: infos && infos.icon ? infos.icon : <WarningTwoTone twoToneColor='#FF0000' />,
        onClick: handleClick,
        onClose: handleClose,
        duration: 0
      })
    }
  }, [loadingInfos])

  return (
    <MatomoProvider value={instanceMatomo}>
      <ConfigProvider theme={{ algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm }}>
        <div className="App">
          {isConnected && <AppContent user={user} logOut={logOut} darkMode={darkMode} onToggleDarkMode={setDarkMode} />}
          {!isConnected && <Login />}
        </div>
      </ConfigProvider>
    </MatomoProvider>
  );
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}
const dispatchToProps = dispatch => {
  return {
    logOut: () => dispatch(logOut())
  }
}

export default connect(mapStateToProps, dispatchToProps)(App);
